var _text, _text2, _text3, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrbanwebhostLogoB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "urban-web-logo-black",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 70",
    role: "img",
    "aria-label": "Urban Web .Host logo - black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#000000"
  }, "Urban")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#00A3E0"
  }, "Web")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#000000"
  }, ".Host")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 55,
    x2: 295,
    y2: 55,
    stroke: "#00A3E0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrbanwebhostLogoB);
export default __webpack_public_path__ + "static/media/Urbanwebhost-Logo_b.8e1b18c54463d798e5e3a8327310ed15.svg";
export { ForwardRef as ReactComponent };